import {useTranslation} from "react-i18next";
import {NavLink} from "react-router-dom";
import Frame from "../Video/frame";
import "./Home2.css";
import {Swiper, SwiperSlide} from 'swiper/react';
import {Autoplay, Navigation, Scrollbar} from 'swiper/modules';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import useAnimation from "../../utils/hooks/animate";
import {useEffect} from "react";

export const Home2 = () => {
    const {i18n, t} = useTranslation();
    const isRutube: boolean = i18n.language === "ru";
    useAnimation();
    useEffect(() => {
        document.title = t("title", {name: ""});
    }, [t]);

    return (
        <main>
            <section>
                <h1 className="text-center header-main animated">{t('home2.1.1')}</h1>
                <p className="text-center animated">{t('home2.1.2')}</p>
                <NavLink className="d-flex justify-content-center" to={"/download"}>
                    {t("action.download")}
                </NavLink>
                <p className="text-center animated">{t('home2.1.3')}</p>
                <div className="d-flex justify-content-center pt-5">
                    <Frame id={isRutube ? "5d410c30e988f9a3648ae22f1f271046" : "TEooFyxKMvM"} title={""} isRutube={isRutube}/>
                </div>
            </section>
            <section>
                <p className="text-center header-main animated">{t('home2.2.1.1')}</p>
                <p className="text-center animated">{t('home2.2.1.2')}</p>
                <ul className="list-group">
                    <li className="list-group-item bg-light"><p className="animated"><strong>{t('home2.2.2.1')}</strong> {t('home2.2.2.2')}</p></li>
                    <li className="list-group-item bg-light"><p className="animated"><strong>{t('home2.2.2.3')}</strong> {t('home2.2.2.4')}</p></li>
                    <li className="list-group-item bg-light"><p className="animated"><strong>{t('home2.2.2.5')}</strong> {t('home2.2.2.6')}</p></li>
                    <li className="list-group-item bg-light"><p className="animated"><strong>{t('home2.2.2.7')}</strong> {t('home2.2.2.8')}</p></li>
                </ul>
            </section>
            <section>
                <p className="text-center header-main animated">{t('home2.8.1')}</p>
                <p className="text-center animated">{t('home2.8.2')}</p>
            </section>
            <section>
                <p className="text-center header-main animated">{t('home2.p.5')}</p>
                <p className="text-center animated">{t('home2.p.6')}</p>
                <Swiper className="pt-5" modules={[Navigation, Scrollbar, Autoplay]} speed={100} loop={true} autoplay={true}
                        direction="horizontal" slidesPerView={5} scrollbar={{draggable: true}} spaceBetween={0}>
                    {[
                        ["Java", "Python", "C++"],
                        ["JavaScript", "Node.js", "Angular"],
                        ["React", "Vue.js", "Ember.js"],
                        ["GitHub", "Apache Tomcat", "Jira"],
                        ["MySQL", "PostgreSQL", "MongoDB"],
                        ["DB2", "OracleDB", "Derby"],
                        ["Google Mail", "Google Sheets"],
                        ["Yandex Mail", "Yandex Alice"],
                        ["Bitcoin", "RabbitMQ", "Telegram"],
                        ["OpenAI Chatbot", "DeepSeek", "Gigachat"],
                        ["LlamaCpp", "TensorFlow", "PyTorch"],
                    ].map((/*[src, text]*/lst, i) => (
                        <SwiperSlide key={i} className="element">
                            {/*<img src={src} alt={text}/>*/}
                            {lst.map((s, j) => (
                                <p key={i + "-" + j} className="text-center animated">{s}</p>
                            ))}
                        </SwiperSlide>
                    ))}
                </Swiper>
            </section>
            <section>
                {/*<h1 className="text-center header-main">Применение</h1>*/}
                <p className="text-center animated">{t('home2.p.7')}</p>
            </section>
            <section>
                <p className="text-center header-main">{t('home2.p.8')}</p>
                <p className="text-center animated">{t('home2.p.9')}</p>
                <p className="text-center animated">{t('home2.p.10')}</p>
                <p className="text-center animated">{t('home2.p.11')}</p>
                <p className="text-center animated">{t('home2.p.12')}</p>
                <p className="text-center animated">{t('home2.p.13')}</p>
                <br/>
                <p className="text-center animated">{t('home2.p.14')}</p>
                <br/>
                <p className="text-center animated">{t('home2.p.15')}</p>
            </section>
            {/*<section>*/}
            {/*    /!*<h1 className="text-center header-main">{t('home2.p.16')}</h1>*!/*/}
            {/*    {[*/}
            {/*        [1, 2, 3],*/}
            {/*        [4, 5, 6],*/}
            {/*    ].map((ids, i) => (*/}
            {/*            <div className="row" key={i}>*/}
            {/*                {ids.map((id, j) => (*/}
            {/*                    <div className="col-sm" key={i + " " + j}>*/}
            {/*                        <div className="card">*/}
            {/*                            <div className="card-body">*/}
            {/*                                <h5 className="card-title">{t('home2.review.' + id + '.title')}</h5>*/}
            {/*                                <p className="card-text animated">{t('home2.review.' + id + '.text')}</p>*/}
            {/*                            </div>*/}
            {/*                        </div>*/}
            {/*                    </div>*/}
            {/*                ))}*/}
            {/*            </div>*/}
            {/*        )*/}
            {/*    )}*/}
            {/*</section>*/}
            <section>
                <p className="text-center header-main">{t('home2.7.1')}</p>
                <p className="text-center animated">
                    {t('home2.7.2')}<span> </span>
                    <a target="_blank" rel="noreferrer"
                        // className="d-flex justify-content-center"
                       href="https://t.me/shelfmc">Telegram</a>
                </p>
                <p className="text-center animated">
                    {t('home2.7.3')} <span> </span>
                    <NavLink
                        // className="d-flex justify-content-center"
                        to={"/video"}>
                        {t("video")}
                    </NavLink>
                </p>
                {/*<p className="text-center animated">*/}
                {/*    {t('home2.7.4')}<span> </span>*/}
                {/*    <a target="_blank" rel="noreferrer"*/}
                {/*        // className="d-flex justify-content-center"*/}
                {/*       href="https://www.reddit.com/r/Shelfmc/">Reddit</a>*/}
                {/*</p>*/}
                <p className="text-center animated">{t('home2.p.20')}</p>
            </section>
        </main>
    );
};